<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";
export default {
  name: "TechnicalSiteMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin, unitConverterMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    /**
     * @return {Array} - the different pole type options
     */
    getLogicalTypeOptions() {
      const logicalTypesFilteredArray = [];
      const logicalTypesArray = this.$store.getters.optionLists_logicalType;
      logicalTypesArray.forEach(item =>{
        if(!item.deleted){
          logicalTypesFilteredArray.push(item);
        }
      })
      return logicalTypesFilteredArray;
    },

    /**
     * @return {Array} - the different height type options
     */
    physicalTypeOptions() {
      return this.$store.getters.optionLists_physicalType;
    },

    fields() {
      return [
        {
          label: this.$i18n.tc("TechnicalSite", 1) + ' ' + this.$i18n.tc("Type", 1),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smts_logical_type], this.getLogicalTypeOptions)
            : this.familySpecificFields.smts_logical_type,
          varName: 'smts_logical_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.getLogicalTypeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("PhysicalType"),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.smts_physical_type], this.physicalTypeOptions)
            : this.familySpecificFields.smts_physical_type,
          varName: 'smts_physical_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.physicalTypeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.t("Length") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smts_length,
          varName: 'smts_length',
          inputType: 'number',
          disabled: false,
          required: true,
          min: '0',
          step: '1',
        },
        {
          label: this.$i18n.t("Width") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smts_width,
          varName: 'smts_width',
          inputType: 'float',
          disabled: false,
          required: true,
          min: '0',
        },
        {
          label: this.$i18n.t("Height") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smts_height,
          varName: 'smts_height',
          inputType: 'float',
          disabled: false,
          required: true,
          min: '0',
        },
      ]
    },
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smts_logical_type &&
        !!this.familySpecificFields.smts_physical_type &&
        !!this.familySpecificFields.smts_length &&
        this.familySpecificFields.smts_length >= 0 &&
        !!this.familySpecificFields.smts_width &&
        this.familySpecificFields.smts_width >= 0 &&
        !!this.familySpecificFields.smts_height &&
        this.familySpecificFields.smts_height >= 0
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsTechnicalSite.vue